import React, { useState } from 'react';
import { ReactComponent as DeleteIcon } from "../image/icons/delsolid.svg";
import { Tooltip } from 'react-tooltip'
import AlertComponent from './AlertComponent';
const DynamicSkillsInputs = ({ inputs, setInputs, setDataSaved }) => {
  const [currentSkill, setCurrentSkill] = useState('');

  const handleChange = (index, event) => {
    const updatedInputs = [...inputs];
    updatedInputs[index][event.target.name] = event.target.value;
    setInputs(updatedInputs);
    setDataSaved(false);
  };

  const handleSkillChange = (index, event) => {
    setCurrentSkill({ value: event.target.value, index });
  };

  const handleSkillKeyDown = (index, event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      addSkill(index);
    }
  };

  const addSkill = (index) => {
    if (currentSkill.value.trim() !== '') {
      const updatedInputs = [...inputs];
      const lastChar = updatedInputs[index].skill_list.slice(-1);
      const newSkill = lastChar === ',' ? `${currentSkill.value}` : `, ${currentSkill.value}`;
      updatedInputs[index].skill_list += newSkill;
      setInputs(updatedInputs);
      setCurrentSkill('');
    }
  };

  const addSection = () => {
    setInputs([...inputs, { title: '', skill_list: '' }]);
    setAccordionIndex(inputs.length);
  };

  const [showAlert, setShowAlert] = useState(false);
  const [indexToRemove, setIndexToRemove] = useState(null);

  const removeSection = (index) => {
  setIndexToRemove(index);
    setShowAlert(true);
}
  const confirmRemoveSection = (index) => {
    const updatedInputs = [...inputs];
    updatedInputs.splice(index, 1);
    setInputs(updatedInputs);
    setShowAlert(false);
    // If the removed accordion is the one that's open, update the accordionIndex
    if (indexToRemove === accordionIndex) {
      setAccordionIndex(updatedInputs.length > 0 ? 0 : null);
    }
  };
  const cancelRemoveSection = () => {
    setShowAlert(false);
  };

  const removeSkill = (sectionIndex, skillToRemove) => {
    const updatedInputs = [...inputs];
    const skills = updatedInputs[sectionIndex].skill_list.split(', ').filter(skill => skill !== '');
    const filteredSkills = skills.filter(skill => skill !== skillToRemove);
    updatedInputs[sectionIndex].skill_list = filteredSkills.join(', ');
    setInputs(updatedInputs);
  };

  // State to manage accordion behavior
  const [accordionIndex, setAccordionIndex] = useState(0);

  // Function to toggle accordion
  const toggleAccordion = (index) => {
    if (accordionIndex === index  && inputs.length > 1) {
      setAccordionIndex(null);
    } else {
      setAccordionIndex(index);
    }
  };

  return (
    <div>
      {inputs.map((input, index) => (
        <div key={index} className="accordion-card cursor-pointer rounded-lg m-3 pl-3 pr-[30px] py-2 border-gray-300 bg-gray-100 border-1">
          <div onClick={() => toggleAccordion(index)} className='text-lg text-gray-600 flex justify-between items-center'>
            {input.title === "" ? (`Skills ${index + 1}`) : (input.title.length > 20 ? `${input.title.slice(0, 20)}...` : input.title)}
            {inputs.length > 1 && (
              <button onClick={() => removeSection(index)} className=" text-white">
                <DeleteIcon className='w-5 h-5 hover:fill-red-600' data-tooltip-id="my-tooltip" data-tooltip-content="Delete" data-tooltip-place="right-end" />
              </button>
            )}
          </div>
          <AlertComponent
            show={showAlert}
            onConfirm={confirmRemoveSection}
            onCancel={cancelRemoveSection}
          />
          {accordionIndex === index && (
            <div className='text-sm text-black'>
              <div className='flex flex-wrap'>
                <div className='w-full md:w-1/2 md:pr-2 mb-2'>
                  <label>Title</label><br />
                  <input
                    type="text"
                    name="title"
                    value={input.title}
                    onChange={(event) => handleChange(index, event)}
                    placeholder="Title"
                    className="border rounded-xl p-2 w-full"
                  />
                </div>
                <div className='w-full'>
                  <label>Skills</label><br />
                  <input
                    type="text"
                    value={currentSkill.index === index ? currentSkill.value : ''}
                    onChange={(event) => handleSkillChange(index, event)}
                    onKeyDown={(event) => handleSkillKeyDown(index, event)}
                    placeholder="Type a skill and press Enter to add"
                    className="border rounded-xl p-2 w-full"
                  />
                </div>
              </div>
              <div className="flex flex-wrap gap-2 my-2">
                {input.skill_list.split(', ').filter(skill => skill !== '').map((skill, skillIndex) => (
                  <div key={skillIndex} className="bg-[#1d6362] text-white border-[1px] rounded-lg border-[#121224] w-fit px-2 py-[6px]">
                    {skill}
                    <button onClick={() => removeSkill(index, skill)} className="text-gray-100 text-xs ml-1">&#x2715;</button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
      <div onClick={addSection} className=" bg-orange-500 rounded-xl text-white m-3 p-2 delay-700 text-lg font-semibold flex justify-center cursor-pointer">
        + Add Skills
      </div>
    </div>
  );
};

export default DynamicSkillsInputs;